import { ReactTypeformEmbed } from 'react-typeform-embed'

export const DevelopersScreen = () => {
  return <ReactTypeformEmbed url='https://justmote.typeform.com/to/IWYwjF7S' />
}
